import React, { forwardRef, useImperativeHandle, useState } from "react";
import { NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper } from "@chakra-ui/react";


interface InputNumberProps {
    min: number;
    max: number;
    defaultValue: number;
    onChange: (value: number) => void;
}


const InputNumber = forwardRef((props: InputNumberProps, ref) => {

    const [number, setNumber] = useState<number|null>(props.defaultValue);

    useImperativeHandle(ref, () => ({
        value() { return number; }
    }));

    return (
        <NumberInput 
            defaultValue={props.defaultValue}
            min={props.min}
            max={props.max}
            onChange={(e) => {
                setNumber(parseInt(e));
                props.onChange(parseInt(e))
            }}
            clampValueOnBlur
        >
            <NumberInputField/>
            <NumberInputStepper>
                <NumberIncrementStepper/>
                <NumberDecrementStepper/>
            </NumberInputStepper>
        </NumberInput>
    );
});

export default InputNumber;